import { getProfileOptions } from '@milestone-portal/api/actions/auth/auth.options';
import { useAuthStore } from '@milestone-portal/context/useAuthStore';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useEffect } from 'react';

import { DefaultError } from './-components/error/DefaultError';

export const Route = createFileRoute('/_authed')({
  beforeLoad: ({ location }) => {
    if (!useAuthStore.getState().authData) {
      throw redirect({
        replace: true,
        search: { from: location.href },
        to: '/',
      });
    }
  },
  component: AuthedLayout,
  /**
   * Suppose all page has there seperate error component, should not fallback to this,
   * unless there has error in the error component.
   */
  errorComponent: DefaultError,
});

function AuthedLayout() {
  const { data } = useQuery(getProfileOptions());
  const { setUser } = useAuthStore();

  useEffect(() => {
    if (data) {
      setUser(data);
    }
  }, [data, setUser]);

  return <Outlet />;
}
